import { EditorConfig } from './editor-config.model';

export interface EditorContainerConfig<Input extends object | void, Form extends object, Output extends object> {
  editor: EditorConfig;
  convertToForm?: (input: Input) => Form;
  convertToOutput?: (form: Form) => Output;
}
